export default __webpack_public_path__ + "static/media/fridge.2ffa9180.svg";